import React, { useEffect, useState } from "react";
import { makeAuthenticatedRequest } from "../utils/api";
import { decrypt, encrypt } from "../utils/cryptoUtils"; // Import encryption utilities
import { Kycsdetails } from "../redux/KycsSlice"; // Corrected import
import { useDispatch, useSelector } from "react-redux";
import { AxiosError } from "../components/sessionexpiry";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Kyc = ({ isSidebarCollapsed, isMobile }) => {
  useEffect(() => {
    fetchData();
  }, []);

  const users = JSON.parse(sessionStorage.getItem("users"));

  // Extract `kycs_step` safely
  const kycsStep = users?.userdatils?.kycs_step
    ? parseInt(users.userdatils.kycs_step, 10)
    : 0;

  const step = {
    0: "General Information",
    1: "Business Address",
    2: "Bank Details",
    3: "KYC",
  };

  const user_id = users?.userdatils?.kycs_step ? users.userdatils.user_id : "0";

  // Set the active section based on `kycs_step`
  const [activeSection, setActiveSection] = useState(
    step[kycsStep] || "General Information"
  );

  // const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const businesstype = {
    1: "Individual",
    2: "LLP",
    3: "Partnership",
    4: "Private Limited",
    5: "Proprietorship",
    6: "NGO",
  };
  
  const data = useSelector((state) => state.login?.loginScreen || []);
  
  const [selectedBusinessType, setSelectedBusinessType] = useState("");
  
  // Set business type after data is available
  useEffect(() => {
    if (data.length > 1 && data[1]["u.business_type"]) {
      const business_id = data[1]["u.business_type"];
      const type = businesstype[business_id];
      setSelectedBusinessType(type);
    }
  }, [data]); // rerun this effect when `data` changes

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const toggleSidebar = () => {
  //   setIsSidebarCollapsed(!isSidebarCollapsed);
  // };

  const [formData, setFormData] = useState({
    user_id: "",
    contact_name: "",
    contact_email: "",
    contact_number: "",
    Country: "",
    business_cname: "",
    business_cnumber: "",
    business_email: "",
    business_type: "",
    business_category: "",
    business_description: "",
    business_name: "",
    accepting_payments: "",
    app_link: "",
    address: "",
    pincode: "",
    city: "",
    state: "",
    bank_account_number: "",
    bank_ifsc_code: "",
    bank_name: "",
    individual_pan: "",
    aadhar_number: "",
    gst_number: "",
    id_document_num: "",
    canceled_cheque: "",
    individual_pan_image: "",
    aadhar_file: "",
    gst_file: "",
    id_proof_image: "",
    company_pan: "",
    pan_number: "",
    company_pan_image: "",
    pan_image: "",
    llp_cerificate_image: "",
    partnership_deed: "",
    moa_aoa_image: "",
    aoa_image: "",
    cin_number: "",
    cin_image: "",
    tan_number: "",
    proprietorship_pan: "",
    proprietorship_pan_image: "",
    reg_certificate_image: "",
  });

  const [isEditable, setIsEditable] = useState({});

  let Josndata = {};
  // Fetch API
  const fetchData = async () => {
    try {
      const requestData = JSON.stringify({
        Dname: "merchant",
        Tname: "kycs",
        Cname: [
          "id",
          "user_id",
          "step",
          "merchant_id",
          "step",
          "country",
          "contact_name",
          "contact_number",
          "contact_email",
          "business_cname",
          "business_cnumber",
          "business_email",
          "business_type",
          "business_category",
          "business_description",
          "accepting_payments",
          "app_link",
          "business_name",
          "address",
          "pincode",
          "city",
          "state",
          "bank_account_number",
          "bank_ifsc_code",
          "bank_name",
          "individual_pan",
          "aadhar_number",
          "gst_number",
          "id_document_num",
          "canceled_cheque",
          "individual_pan_image",
          "aadhar_file",
          "gst_file",
          "id_proof_image",
          "company_pan",
          "pan_number",
          "company_pan_image",
          "pan_image",
          "llp_cerificate_image",
          "partnership_deed",
          "moa_aoa_image",
          "aoa_image",
          "cin_number",
          "cin_image",
          "tan_number",
          "proprietorship_pan",
          "proprietorship_pan_image",
          "reg_certificate_image",
        ],
        Where: [
          { 
            column: "user_id",
            operator: "=",
            value: user_id 
          },
        ],
        Limit: "10",
        Offset: "0",
      });

      const encrypted = encrypt(requestData);
      const response = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted },
        navigate
      );
      const decryptdata = decrypt(response);
      const jsonArray = JSON.parse(decryptdata.replace(/\\"/g, '"'));

      dispatch(Kycsdetails(jsonArray)); // Pass the entire response

      if (!jsonArray.length) return;

      const updatedData = {
        user_id: jsonArray[1].user_id || "",
        contact_name: jsonArray[1].contact_name || "",
        contact_email: jsonArray[1].contact_email || "",
        contact_number: jsonArray[1].contact_number || "",
        Country: jsonArray[1].country || "",
        business_cname: jsonArray[1].business_cname || "",
        business_cnumber: jsonArray[1].business_cnumber || "",
        business_email: jsonArray[1].business_email || "",
        business_type: jsonArray[1].business_type || "",
        business_category: jsonArray[1].business_category || "",
        business_description: jsonArray[1].business_description || "",
        business_name: jsonArray[1].business_name || "",
        accepting_payments: jsonArray[1].accepting_payments || "",
        app_link: jsonArray[1].app_link || "",
        address: jsonArray[1].address || "",
        pincode: jsonArray[1].pincode || "",
        city: jsonArray[1].city || "",
        state: jsonArray[1].state || "",
        bank_account_number: jsonArray[1].bank_account_number || "",
        bank_ifsc_code: jsonArray[1].bank_ifsc_code || "",
        bank_name: jsonArray[1].bank_name || "",
        individual_pan: jsonArray[1].individual_pan || "",
        aadhar_number: jsonArray[1].aadhar_number || "",
        gst_number: jsonArray[1].gst_number || "",
        id_document_num: jsonArray[1].id_document_num || "",
        canceled_cheque: jsonArray[1].canceled_cheque || "",
        individual_pan_image: jsonArray[1].individual_pan_image || "",
        aadhar_file: jsonArray[1].aadhar_file || "",
        gst_file: jsonArray[1].gst_file || "",
        id_proof_image: jsonArray[1].id_proof_image || "",
        company_pan: jsonArray[1].company_pan || "",
        pan_number: jsonArray[1].pan_number || "",
        company_pan_image: jsonArray[1].company_pan_image || "",
        pan_image: jsonArray[1].pan_image || "",
        llp_cerificate_image: jsonArray[1].llp_cerificate_image || "",
        partnership_deed: jsonArray[1].partnership_deed || "",
        moa_aoa_image: jsonArray[1].moa_aoa_image || "",
        aoa_image: jsonArray[1].aoa_image || "",
        cin_number: jsonArray[1].cin_number || "",
        cin_image: jsonArray[1].cin_image || "",
        tan_number: jsonArray[1].tan_number || "",
        proprietorship_pan: jsonArray[1].proprietorship_pan || "",
        proprietorship_pan_image: jsonArray[1].proprietorship_pan_image || "",
        reg_certificate_image: jsonArray[1].reg_certificate_image || "",
      };

      setFormData(updatedData);

      // Set editable state: Read-only if data exists
      setIsEditable(
        Object.fromEntries(
          Object.entries(updatedData).map(([key, value]) => [key, !value])
        )
      );

      // Check for empty fields and update them
      const missingFields = Object.keys(updatedData).filter(
        (key) => !updatedData[key]
      );

      if (missingFields.length > 0) {
        Josndata = Object.fromEntries(missingFields.map((key) => [key, ``]));
      }
    } catch (error) {
      AxiosError(navigate, error);
      console.error("Error fetching data:", error);
    }
  };
  // Update API
  const updateData = async (data, status) => {
    try {
      // console.log("Final JSON:", formData);
      // console.log(Object.keys(formData)); // ["name", "age", "city"]
      // console.log(Object.values(formData)); // ["John", 30, "New York"]

      // Convert to JSON string
      const json = JSON.stringify({
        Dname: "merchant",
        Tname: "kycs",
        Set: {
          ...formData, // Spread existing formData
          step: data,
          activate_status: status,
        },
        Where: {
          user_id: user_id,
        },
        Limit: "1",
      });

      console.log("Final JSON:", json);

      const encrypted = encrypt(json);

      const response = await makeAuthenticatedRequest(
        "POST",
        "/update",
        { encrypted: encrypted },
        navigate
      );

      const decryptdata = decrypt(response);
      const jsonArray = JSON.parse(decryptdata.replace(/\\"/g, '"'));

      if (jsonArray["Status count"] === "200") {
        // Corrected property access
        // toast.success("Data updated successfully");
      } else {
        toast.error("Update failed");
      }
    } catch (error) {
      AxiosError(navigate, error);
      console.error("Error updating data:", error);
    }
  };

  // ---------------------------- *** -------------------------------

  const [individual_pan_image, setindividual_pan_image] = useState();
  const [aadhar_file, setaadhar_file] = useState();
  const [gst_file, setgst_file] = useState();
  const [id_proof_image, setid_proof_image] = useState();
  const [canceled_cheque, setcanceled_cheque] = useState();
  const [company_pan_image, setcompany_pan_image] = useState();
  const [pan_image, setpan_image] = useState();
  const [llp_cerificate_image, setllp_cerificate_image] = useState();
  const [partnership_deed, setpartnership_deed] = useState();
  const [moa_aoa_image, setmoa_aoa_image] = useState();
  const [aoa_image, setaoa_image] = useState();
  const [cin_image, setcin_image] = useState();
  const [proprietorship_pan_image, setproprietorship_pan_image] = useState();
  const [reg_certificate_image, setreg_certificate_image] = useState();
  const [status, setStatus] = useState({ message: "", type: "" });
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e, setFile) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const uploadFiles = async () => {
    // Clear previous status
    setStatus({ message: "", type: "" });

    const token = sessionStorage.getItem("token");

    // Validate required files
    // if (!individual_pan_image || !aadhar_file || !gst_file || !id_proof_image || !canceled_cheque) {
    //   setStatus({ message: 'Please upload at least the Document Front and Selfie!', type: 'error' });
    //   return;
    // }

    // Prepare form data
    const formData = new FormData();
    if (individual_pan_image)
      formData.append("individual_pan_image", individual_pan_image);
    if (gst_file) formData.append("gst_file", gst_file);
    if (aadhar_file) formData.append("aadhar_file", aadhar_file);
    if (id_proof_image) formData.append("id_proof_image", id_proof_image);
    if (canceled_cheque) formData.append("canceled_cheque", canceled_cheque);
    if (company_pan_image)
      formData.append("company_pan_image", company_pan_image);
    if (pan_image) formData.append("pan_image", pan_image);
    if (llp_cerificate_image)
      formData.append("llp_cerificate_image", llp_cerificate_image);
    if (partnership_deed) formData.append("partnership_deed", partnership_deed);
    if (moa_aoa_image) formData.append("moa_aoa_image", moa_aoa_image);
    if (aoa_image) formData.append("aoa_image", aoa_image);
    if (cin_image) formData.append("cin_image", cin_image);
    if (proprietorship_pan_image)
      formData.append("proprietorship_pan_image", proprietorship_pan_image);
    if (reg_certificate_image)
      formData.append("reg_certificate_image", reg_certificate_image);
    // formData.append('userId', '7');  // Assuming '7' is the user ID from the URL

    setIsUploading(true);
    setStatus({ message: "Uploading files...", type: "" });

    try {
      const response = await fetch(
        `https://merchant-api.jantapays.com/kyc/documents/upload/${user_id}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.message || `Server responded with status ${response.status}`
        );
      }

      const result = await response.json();
      console.log("Upload successful:", result);
      setStatus({ message: "Files uploaded successfully!", type: "success" });

      const decryptdata = decrypt(result.data);
      const jsonArray = JSON.parse(decryptdata.replace(/\\"/g, '"'));

      if (jsonArray["status"] === "success") {
        // Corrected property access
        toast.success("Document updated successfully");
        setActiveSection("General Information");
      } else {
        toast.error("Update failed");
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setStatus({ message: `Upload failed: ${error.message}`, type: "error" });
    } finally {
      setIsUploading(false);
    }
  };

  const handleViewFile = (file) => {
    if (file) {
      const fileURL = `https://merchant-image.jantapays.com/images${
        file.startsWith("/") ? file : "/" + file
      }`;
      window.open(fileURL, "_blank"); // Open file in new tab
    }
  };

  ///error message - GeneralInformationInput

  const [CountryError, setCountryError] = useState("");
  const [ContactNameError, setContactNameError] = useState("");
  const [ContactEmailError, setContactEmailError] = useState("");
  const [ContactNumberError, setContactNumberError] = useState("");
  // const [BusinessNameError ,setBusinessNameError ] = useState('');
  const [BusinessCatError, setBusinessCatError] = useState("");
  const [AcceptUrlError, setAcceptUrlError] = useState("");
  const [AppUrlError, setAppUrlError] = useState("");
  const [DescriptionError, setDescriptionError] = useState("");

  const GeneralInformationInput = () => {
    let isValid = true;

    if (formData.Country.trim() === "") {
      setCountryError("Country is required.");
      isValid = false;
    } else {
      setCountryError("");
    }

    if (formData.business_cname === "") {
      setContactNameError("Contact Name is required.");
      isValid = false;
    } else {
      setContactNameError("");
    }

    if (formData.business_email === "") {
      setContactEmailError("Contact Email is required.");
      isValid = false;
    } else {
      setContactEmailError("");
    }

    if (formData.business_cnumber === "") {
      setContactNumberError("Contact Number is required.");
      isValid = false;
    } else {
      setContactNumberError("");
    }

    // if (formData.business_cname === '') {
    //   setBusinessNameError('Business Name is required!');
    //   isValid = false;
    // } else {
    //   setBusinessNameError('');
    // }

    if (formData.business_category === "") {
      setBusinessCatError("Business Category is required.");
      isValid = false;
    } else {
      setBusinessCatError("");
    }

    if (formData.accepting_payments === "") {
      setAcceptUrlError("Accept URL is required.");
      isValid = false;
    } else {
      setAcceptUrlError("");
    }

    if (formData.app_link === "") {
      setAppUrlError("App URL is required.");
      isValid = false;
    } else {
      setAppUrlError("");
    }

    if (formData.business_description === "") {
      setDescriptionError("Description is required.");
      isValid = false;
    } else {
      setDescriptionError("");
    }

    if (isValid) {
      setActiveSection("Business Address");
      updateData(1);
    }

    // setActiveSection("Business Address");
    // updateData(1);

    return isValid;
  };

  //Business Address Error Message
  const [AddressError, setAddressError] = useState("");
  const [PincodeError, setPincodeError] = useState("");
  const [CityError, setCityError] = useState("");
  const [StateError, setStateError] = useState("");

  const BusinessAddressInput = () => {
    let isValid = true;

    if (formData.address === "") {
      setAddressError("Address is required.");
      isValid = false;
    } else {
      setAddressError("");
    }

    if (!formData.pincode) {
      setPincodeError("Pincode is required.");
      isValid = false;
    } else {
      setPincodeError("");
    }

    if (!formData.city) {
      setCityError("City is required.");
      isValid = false;
    } else {
      setCityError("");
    }

    if (!formData.state) {
      setStateError("State is required.");
      isValid = false;
    } else {
      setStateError("");
    }

    if (isValid) {
      setActiveSection("Bank Details");
      updateData(2);
    }

    return isValid;
  };

  const [AccountNumberError, setAccountNumberError] = useState("");
  const [BankIFSCError, setBankIFSCError] = useState("");
  const [BankNameError, setBankNameError] = useState("");

  const BankDetailsInput = () => {
    let isValid = true;

    if (!formData.bank_account_number) {
      setAccountNumberError("Account Number is required.");
      isValid = false;
    } else {
      setAccountNumberError("");
    }

    if (!formData.bank_ifsc_code) {
      setBankIFSCError("Bank IFSC Code is required.");
      isValid = false;
    } else {
      setBankIFSCError("");
    }

    if (!formData.bank_name) {
      setBankNameError("Bank Name is required.");
      isValid = false;
    } else {
      setBankNameError("");
    }

    if (isValid) {
      setActiveSection("KYC");
      updateData(3);
    }

    return isValid;
  };

  //Private Limited
  const [CompanyPanNumberError, setCompanyPanNumberError] = useState("");
  const [CompanyPanFileError, setCompanyPanFileError] = useState("");
  const [PanNumberError, setPanNumberError] = useState("");
  const [PanFileError, setPanFileError] = useState("");
  const [AadharNumberError, setAadharNumberError] = useState("");
  const [AadharFileError, setAadharFileError] = useState("");
  const [GSTNumberError, setGSTNumberError] = useState("");
  const [GSTFileError, setGSTFileError] = useState("");
  const [CINNumberError, setCINNumberError] = useState("");
  const [CINFileError, setCINFileError] = useState("");
  const [MOAAOAFileError, setMOAAOAFileError] = useState("");
  const [AOAFileError, setAOAFileError] = useState("");
  const [IDProofNumberError, setIDProofNumberError] = useState("");
  const [IDProofFileError, setIDProofFileError] = useState("");
  const [CancelChequeError, setCancelChequeError] = useState("");
  const [TANNumberError, setTANNumberError] = useState("");

  //indivual
  const [IndiPanNumberError, setIndiPanNumberError] = useState("");
  const [IndiPanFileError, setIndiPanFileError] = useState("");
  const [IndiAadharNumberError, setIndiAadharNumberError] = useState("");
  const [IndiAadharFileError, setIndiAadharFileError] = useState("");
  const [IndiGSTNumberError, setIndiGSTNumberError] = useState("");
  const [IndiGSTFileError, setIndiGSTFileError] = useState("");
  const [IndiIDProofError, setIndiIDProofError] = useState("");
  const [IndiIDProofFileError, setIndiIDProofFileError] = useState("");
  const [IndiCancelChequeError, setIndiCancelChequeError] = useState("");

  //LLP
  const [llpCompanyPanNumberError, setllpCompanyPanNumberError] = useState("");
  const [llpCompanyPanFileError, setllpCompanyPanFileError] = useState("");
  const [llpPanNumberError, setllpPanNumberError] = useState("");
  const [llpPanFileError, setllpPanFileError] = useState("");
  const [llpAadharNumberError, setllpAadharNumberError] = useState("");
  const [llpAadharFileError, setllpAadharFileError] = useState("");
  const [llpGSTNumberError, setllpGSTNumberError] = useState("");
  const [llpGSTFileError, setllpGSTFileError] = useState("");
  const [llpIDProofNumberError, setllpIDProofNumberError] = useState("");
  const [llpIDProofFileError, setllpIDProofFileError] = useState("");
  const [LLPCertificateError, setLLPCertificateError] = useState("");
  const [llpCancelChequeError, setllpCancelChequeError] = useState("");

  //Patrner Ship
  const [parCompanyPanNumberError, setparCompanyPanNumberError] = useState("");
  const [parCompanyPanFileError, setparCompanyPanFileError] = useState("");
  const [parPanNumberError, setparPanNumberError] = useState("");
  const [parPanFileError, setparPanFileError] = useState("");
  const [parAadharNumberError, setparAadharNumberError] = useState("");
  const [parAadharFileError, setparAadharFileError] = useState("");
  const [parGSTNumberError, setparGSTNumberError] = useState("");
  const [parGSTFileError, setparGSTFileError] = useState("");
  const [parIDProofNumberError, setparIDProofNumberError] = useState("");
  const [parIDProofFileError, setparIDProofFileError] = useState("");
  const [PartnerShipFileError, setPartnerShipFileError] = useState("");
  const [parCancelChequeErrorError, setparCancelChequeErrorError] =
    useState("");

  //ProprietorShip

  const [ProprietorPanNumberError, setProprietorPanNumberError] = useState("");
  const [ProprietorPanFileError, setProprietorPanFileError] = useState("");
  const [ProAadharNumberError, setProAadharNumberError] = useState("");
  const [ProAadharFileError, setProAadharFileError] = useState("");
  const [ProGSTNumberError, setProGSTNumberError] = useState("");
  const [ProGSTFileError, setProGSTFileError] = useState("");
  const [ProIDProofNumberError, setProIDProofNumberError] = useState("");
  const [ProIDProofFileError, setProIDProofFileError] = useState("");
  const [ProRegisterFileError, setProRegisterFileError] = useState("");
  const [ProCancelChequeError, setProCancelChequeError] = useState("");

  const KYCSubmitInput = () => {

    //ProprietorShip --done
    if (formData.business_type === "5") {
      let isValid = true;
      // PAN Number
      if (!formData.proprietorship_pan) {
        setProprietorPanNumberError("PAN Number is required!");
        isValid = false;
      } else {
        setProprietorPanNumberError("");
      }

      if (!proprietorship_pan_image && !formData.proprietorship_pan_image) {
        setProprietorPanFileError("PAN File is required!");
        isValid = false;
      } else if (proprietorship_pan_image) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(proprietorship_pan_image.type)) {
          setProprietorPanFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (proprietorship_pan_image.size > maxSize) {
          setProprietorPanFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setProprietorPanFileError("");
        }
      } else {
        setProprietorPanFileError("");
      }      
      

      // Aadhar Number
      if (!formData.aadhar_number) {
        setProAadharNumberError("Aadhar Number is required!");
        isValid = false;
      } else {
        setProAadharNumberError("");
      }

      if (!aadhar_file && !formData.aadhar_file) {
        setProAadharFileError("Aadhar File is required!");
        isValid = false;
      } else if (aadhar_file) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(aadhar_file.type)) {
          setProAadharFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (aadhar_file.size > maxSize) {
          setProAadharFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setProAadharFileError("");
        }
      } else {
        setProAadharFileError("");
      }
      

      // GST Number
      if (!formData.gst_number) {
        setProGSTNumberError("GST Number is required!");
        isValid = false;
      } else {
        setProGSTNumberError("");
      }

      if (!gst_file && !formData.gst_file) {
        setProGSTFileError("GST File is required!");
        isValid = false;
      } else if (gst_file) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(gst_file.type)) {
          setProGSTFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (gst_file.size > maxSize) {
          setProGSTFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setProGSTFileError("");
        }
      } else {
        setProGSTFileError("");
      }
      

      // ID Proof Number
      if (!formData.id_document_num) {
        setProIDProofNumberError("ID Proof Number is required!");
        isValid = false;
      } else {
        setProIDProofNumberError("");
      }

      if (!id_proof_image && !formData.id_proof_image) {
        setProIDProofFileError("ID Proof File is required!");
        isValid = false;
      } else if (id_proof_image) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(id_proof_image.type)) {
          setProIDProofFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (id_proof_image.size > maxSize) {
          setProIDProofFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setProIDProofFileError("");
        }
      } else {
        setProIDProofFileError("");
      }
      

      if (!reg_certificate_image && !formData.reg_certificate_image) {
        setProRegisterFileError("Registration Certificate is required!");
        isValid = false;
      } else if (reg_certificate_image) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(reg_certificate_image.type)) {
          setProRegisterFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (reg_certificate_image.size > maxSize) {
          setProRegisterFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setProRegisterFileError("");
        }
      } else {
        setProRegisterFileError("");
      }
      

      if (!canceled_cheque && !formData.canceled_cheque) {
        setProCancelChequeError("Cancelled Cheque is required!");
        isValid = false;
      } else if (canceled_cheque) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(canceled_cheque.type)) {
          setProCancelChequeError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (canceled_cheque.size > maxSize) {
          setProCancelChequeError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setProCancelChequeError("");
        }
      } else {
        setProCancelChequeError("");
      }
      

      // If all is valid, you can now move to the next section
      if (isValid) {
        updateData(4, 1);
        uploadFiles();
      }

      return isValid;
    }

    //Patrner Ship - done
    if (formData.business_type === "3") {
      let isValid = true;
      // Company PAN Number
      if (!formData.company_pan) {
        setparCompanyPanNumberError("Company PAN Number is required!");
        isValid = false;
      } else {
        setparCompanyPanNumberError("");
      }

      // Company PAN File Validation (required, format, size)
      if (!company_pan_image) {
        setparCompanyPanFileError("Company PAN File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(company_pan_image.type)) {
          setparCompanyPanFileError(
            "Only JPG, JPEG, PNG, or PDF files are allowed."
          );
          isValid = false;
        } else if (company_pan_image.size > maxSize) {
          setparCompanyPanFileError(
            "File size must be less than or equal to 5MB."
          );
          isValid = false;
        } else {
          setparCompanyPanFileError("");
        }
      }

      // Partner PAN Number
      if (!formData.pan_number) {
        setparPanNumberError("Partner PAN Number is required!");
        isValid = false;
      } else {
        setparPanNumberError("");
      }

      // Partner PAN File Validation (required, format, size)
      if (!pan_image) {
        setparPanFileError("Partner PAN File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(pan_image.type)) {
          setparPanFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (pan_image.size > maxSize) {
          setparPanFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setparPanFileError("");
        }
      }

      // Aadhar Number
      if (!formData.aadhar_number) {
        setparAadharNumberError("Aadhar Number is required!");
        isValid = false;
      } else {
        setparAadharNumberError("");
      }

      // Aadhar File Validation (required, format, size)
      if (!aadhar_file) {
        setparAadharFileError("Aadhar File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(aadhar_file.type)) {
          setparAadharFileError(
            "Only JPG, JPEG, PNG, or PDF files are allowed."
          );
          isValid = false;
        } else if (aadhar_file.size > maxSize) {
          setparAadharFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setparAadharFileError("");
        }
      }

      // GST Number
      if (!formData.gst_number) {
        setparGSTNumberError("GST Number is required!");
        isValid = false;
      } else {
        setparGSTNumberError("");
      }

      // GST File Validation (required, format, size)
      if (!gst_file) {
        setparGSTFileError("GST File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(gst_file.type)) {
          setparGSTFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (gst_file.size > maxSize) {
          setparGSTFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setparGSTFileError("");
        }
      }

      // ID Proof Number
      if (!formData.id_document_num) {
        setparIDProofNumberError("ID Proof Number is required!");
        isValid = false;
      } else {
        setparIDProofNumberError("");
      }

      // ID Proof File Validation (required, format, size)
      if (!id_proof_image) {
        setparIDProofFileError("ID Proof File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(id_proof_image.type)) {
          setparIDProofFileError(
            "Only JPG, JPEG, PNG, or PDF files are allowed."
          );
          isValid = false;
        } else if (id_proof_image.size > maxSize) {
          setparIDProofFileError(
            "File size must be less than or equal to 5MB."
          );
          isValid = false;
        } else {
          setparIDProofFileError("");
        }
      }

      // Partnership Deed File Validation (required, format, size)
      if (!partnership_deed) {
        setPartnerShipFileError("Partnership Deed File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(partnership_deed.type)) {
          setPartnerShipFileError(
            "Only JPG, JPEG, PNG, or PDF files are allowed."
          );
          isValid = false;
        } else if (partnership_deed.size > maxSize) {
          setPartnerShipFileError(
            "File size must be less than or equal to 5MB."
          );
          isValid = false;
        } else {
          setPartnerShipFileError("");
        }
      }

      // Cancelled Cheque Validation (required, format, size)
      if (!canceled_cheque) {
        setparCancelChequeErrorError("Cancelled Cheque is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(canceled_cheque.type)) {
          setparCancelChequeErrorError(
            "Only JPG, JPEG, PNG, or PDF files are allowed."
          );
          isValid = false;
        } else if (canceled_cheque.size > maxSize) {
          setparCancelChequeErrorError(
            "File size must be less than or equal to 5MB."
          );
          isValid = false;
        } else {
          setparCancelChequeErrorError("");
        }
      }

      // If all is valid, you can now move to the next section
      if (isValid) {
        updateData(4, 1);
        uploadFiles();
      }

      return isValid;
    }

    //LLp  --done
    if (formData.business_type === "2") {
      let isValid = true;

      // Company PAN Number
      if (!formData.company_pan) {
        setllpCompanyPanNumberError("Company PAN Number is required!");
        isValid = false;
      } else {
        setllpCompanyPanNumberError("");
      }

      // Company PAN File Validation (required, format, size)
      if (!company_pan_image) {
        setllpCompanyPanFileError("Company PAN File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(company_pan_image.type)) {
          setllpCompanyPanFileError(
            "Only JPG, JPEG, PNG, or PDF files are allowed."
          );
          isValid = false;
        } else if (company_pan_image.size > maxSize) {
          setllpCompanyPanFileError(
            "File size must be less than or equal to 5MB."
          );
          isValid = false;
        } else {
          setllpCompanyPanFileError("");
        }
      }

      // Partner PAN Number
      if (!formData.pan_number) {
        setllpPanNumberError("Partner PAN Number is required!");
        isValid = false;
      } else {
        setllpPanNumberError("");
      }

      // Partner PAN File Validation (required, format, size)
      if (!pan_image) {
        setllpPanFileError("Partner PAN File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(pan_image.type)) {
          setllpPanFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (pan_image.size > maxSize) {
          setllpPanFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setllpPanFileError("");
        }
      }

      // Partner Aadhar Number
      if (!formData.aadhar_number) {
        setllpAadharNumberError("Aadhar Number is required!");
        isValid = false;
      } else {
        setllpAadharNumberError("");
      }

      // Aadhar File Validation (required, format, size)
      if (!aadhar_file) {
        setllpAadharFileError("Aadhar File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(aadhar_file.type)) {
          setllpAadharFileError(
            "Only JPG, JPEG, PNG, or PDF files are allowed."
          );
          isValid = false;
        } else if (aadhar_file.size > maxSize) {
          setllpAadharFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setllpAadharFileError("");
        }
      }

      // GST Number
      if (!formData.gst_number) {
        setllpGSTNumberError("GST Number is required!");
        isValid = false;
      } else {
        setllpGSTNumberError("");
      }

      // GST File Validation (required, format, size)
      if (!gst_file) {
        setllpGSTFileError("GST File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(gst_file.type)) {
          setllpGSTFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (gst_file.size > maxSize) {
          setllpGSTFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setllpGSTFileError("");
        }
      }

      // ID Proof Number
      if (!formData.id_document_num) {
        setllpIDProofNumberError("ID Proof Number is required!");
        isValid = false;
      } else {
        setllpIDProofNumberError("");
      }

      // ID Proof File Validation (required, format, size)
      if (!id_proof_image) {
        setllpIDProofFileError("ID Proof File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(id_proof_image.type)) {
          setllpIDProofFileError(
            "Only JPG, JPEG, PNG, or PDF files are allowed."
          );
          isValid = false;
        } else if (id_proof_image.size > maxSize) {
          setllpIDProofFileError(
            "File size must be less than or equal to 5MB."
          );
          isValid = false;
        } else {
          setllpIDProofFileError("");
        }
      }

      // LLP Incorporation Certificate Validation (required, format, size)
      if (!llp_cerificate_image) {
        setLLPCertificateError("Incorporation Certificate is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(llp_cerificate_image.type)) {
          setLLPCertificateError(
            "Only JPG, JPEG, PNG, or PDF files are allowed."
          );
          isValid = false;
        } else if (llp_cerificate_image.size > maxSize) {
          setLLPCertificateError(
            "File size must be less than or equal to 5MB."
          );
          isValid = false;
        } else {
          setLLPCertificateError("");
        }
      }

      // Cancelled Cheque Validation (required, format, size)
      if (!canceled_cheque) {
        setllpCancelChequeError("Cancelled Cheque is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!allowedTypes.includes(canceled_cheque.type)) {
          setllpCancelChequeError(
            "Only JPG, JPEG, PNG, or PDF files are allowed."
          );
          isValid = false;
        } else if (canceled_cheque.size > maxSize) {
          setllpCancelChequeError(
            "File size must be less than or equal to 5MB."
          );
          isValid = false;
        } else {
          setllpCancelChequeError("");
        }
      }

      // If all is valid, you can now move to the next section
      if (isValid) {
        updateData(4, 1);
        uploadFiles();
      }
    }

    //Indivual --done
    if (formData.business_type === "1") {
      let isValid = true;

      // PAN Number
      if (!formData.individual_pan) {
        setIndiPanNumberError("PAN Number is required!");
        isValid = false;
      } else {
        setIndiPanNumberError("");
      }

      // PAN File Validation (required, format, size)
      if (!individual_pan_image) {
        setIndiPanFileError("PAN File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 1 * 1000 * 1000; // 1MB

        if (!allowedTypes.includes(individual_pan_image.type)) {
          setIndiPanFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (individual_pan_image.size > maxSize) {
          setIndiPanFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setIndiPanFileError("");
        }
      }

      // Aadhaar Number
      if (!formData.aadhar_number) {
        setIndiAadharNumberError("Aadhaar Number is required!");
        isValid = false;
      } else {
        setIndiAadharNumberError("");
      }

      // Aadhaar File Validation (required, format, size)
      if (!aadhar_file) {
        setIndiAadharFileError("Aadhaar File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 1 * 1000 * 1000; // 1MB

        if (!allowedTypes.includes(aadhar_file.type)) {
          setIndiAadharFileError(
            "Only JPG, JPEG, PNG, or PDF files are allowed."
          );
          isValid = false;
        } else if (aadhar_file.size > maxSize) {
          setIndiAadharFileError(
            "File size must be less than or equal to 5MB."
          );
          isValid = false;
        } else {
          setIndiAadharFileError("");
        }
      }

      // GST Number
      if (!formData.gst_number) {
        setIndiGSTNumberError("GST Number is required!");
        isValid = false;
      } else {
        setIndiGSTNumberError("");
      }

      // GST File Validation (required, format, size)
      if (!gst_file) {
        setIndiGSTFileError("GST File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 1 * 1000 * 1000; // 1MB

        if (!allowedTypes.includes(gst_file.type)) {
          setIndiGSTFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (gst_file.size > maxSize) {
          setIndiGSTFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setIndiGSTFileError("");
        }
      }

      // ID Proof Type
      if (!formData.id_document_num) {
        setIndiIDProofError("ID Proof type is required!");
        isValid = false;
      } else {
        setIndiIDProofError("");
      }

      // ID Proof File Validation (required, format, size)
      if (!id_proof_image) {
        setIndiIDProofFileError("ID Proof File is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 1 * 1000 * 1000; // 1MB

        if (!allowedTypes.includes(id_proof_image.type)) {
          setIndiIDProofFileError(
            "Only JPG, JPEG, PNG, or PDF files are allowed."
          );
          isValid = false;
        } else if (id_proof_image.size > maxSize) {
          setIndiIDProofFileError(
            "File size must be less than or equal to 5MB."
          );
          isValid = false;
        } else {
          setIndiIDProofFileError("");
        }
      }

      // Cancelled Cheque File Validation (required, format, size)
      if (!canceled_cheque) {
        setIndiCancelChequeError("Cancelled Cheque is required!");
        isValid = false;
      } else {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
        ];
        const maxSize = 1 * 1000 * 1000; // 1MB

        if (!allowedTypes.includes(canceled_cheque.type)) {
          setIndiCancelChequeError(
            "Only JPG, JPEG, PNG, or PDF files are allowed."
          );
          isValid = false;
        } else if (canceled_cheque.size > maxSize) {
          setIndiCancelChequeError(
            "File size must be less than or equal to 5MB."
          );
          isValid = false;
        } else {
          setIndiCancelChequeError("");
        }
      }

      // If all is valid, you can now move to the next section
      if (isValid) {
        updateData(4, 1);
        uploadFiles();
      }

      return isValid;
    }

    //Private Limited - done
    if (formData.business_type === "4") {
      let isValid = true;
      if (!formData.company_pan) {
        setCompanyPanNumberError("Company PAN Number is required!");
        isValid = false;
      } else {
        setCompanyPanNumberError("");
      }

      if (!company_pan_image && !formData.company_pan_image) {
        setCompanyPanFileError("Company PAN File is required!");
        isValid = false;
      } else if (company_pan_image) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(company_pan_image.type)) {
          setCompanyPanFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (company_pan_image.size > maxSize) {
          setCompanyPanFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setCompanyPanFileError("");
        }
      } else {
        setCompanyPanFileError("");
      }
      

      if (!formData.pan_number) {
        setPanNumberError("PAN Number is required!");
        isValid = false;
      } else {
        setPanNumberError("");
      }

      if (!pan_image && !formData.pan_image) {
        setPanFileError("PAN File is required!");
        isValid = false;
      } else if (pan_image) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(pan_image.type)) {
          setPanFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (pan_image.size > maxSize) {
          setPanFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setPanFileError("");
        }
      } else {
        setPanFileError("");
      }
      

      if (!formData.aadhar_number) {
        setAadharNumberError("Aadhar Number is required!");
        isValid = false;
      } else {
        setAadharNumberError("");
      }

      if (!aadhar_file && !formData.aadhar_file) {
        setAadharFileError("Aadhar File is required!");
        isValid = false;
      } else if (aadhar_file) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(aadhar_file.type)) {
          setAadharFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (aadhar_file.size > maxSize) {
          setAadharFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setAadharFileError("");
        }
      } 
      

      if (!formData.gst_number) {
        setGSTNumberError("GST Number is required!");
        isValid = false;
      } else {
        setGSTNumberError("");
      }

      if (!gst_file && !formData.gst_file) {
        setGSTFileError("GST File is required!");
        isValid = false;
      } else if (gst_file) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(gst_file.type)) {
          setGSTFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (gst_file.size > maxSize) {
          setGSTFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setGSTFileError("");
        }
      } else {
        setGSTFileError("");
      }
      

      if (!formData.cin_number) {
        setCINNumberError("CIN Number is required!");
        isValid = false;
      } else {
        setCINNumberError("");
      }

      if (!cin_image && !formData.cin_image) {
        setCINFileError("CIN File is required!");
        isValid = false;
      } else if (cin_image) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(cin_image.type)) {
          setCINFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (cin_image.size > maxSize) {
          setCINFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setCINFileError("");
        }
      } else {
        setCINFileError("");
      }
      

      if (!moa_aoa_image && !formData.moa_aoa_image) {
        setMOAAOAFileError("MOA/AOA File is required!");
        isValid = false;
      } else if (moa_aoa_image) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(moa_aoa_image.type)) {
          setMOAAOAFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (moa_aoa_image.size > maxSize) {
          setMOAAOAFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setMOAAOAFileError("");
        }
      } else {
        setMOAAOAFileError("");
      }
      

      if (!aoa_image && !formData.aoa_image) {
        setAOAFileError("AOA File is required!");
        isValid = false;
      } else if (aoa_image) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(aoa_image.type)) {
          setAOAFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (aoa_image.size > maxSize) {
          setAOAFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setAOAFileError("");
        }
      } else {
        setAOAFileError("");
      }
      

      if (!formData.id_document_num) {
        setIDProofNumberError("ID Proof Number is required!");
        isValid = false;
      } else {
        setIDProofNumberError("");
      }

      if (!id_proof_image && !formData.id_proof_image) {
        setIDProofFileError("ID Proof File is required!");
        isValid = false;
      } else if (id_proof_image) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(id_proof_image.type)) {
          setIDProofFileError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (id_proof_image.size > maxSize) {
          setIDProofFileError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setIDProofFileError("");
        }
      } else {
        setIDProofFileError("");
      }
      

      if (!canceled_cheque && !formData.canceled_cheque) {
        setCancelChequeError("Cancelled Cheque is required!");
        isValid = false;
      } else if (canceled_cheque) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const maxSize = 5 * 1024 * 1024; // 5MB
      
        if (!allowedTypes.includes(canceled_cheque.type)) {
          setCancelChequeError("Only JPG, JPEG, PNG, or PDF files are allowed.");
          isValid = false;
        } else if (canceled_cheque.size > maxSize) {
          setCancelChequeError("File size must be less than or equal to 5MB.");
          isValid = false;
        } else {
          setCancelChequeError("");
        }
      } else {
        setCancelChequeError("");
      }
      

      if (!formData.tan_number) {
        setTANNumberError("TAN Number is required!");
        isValid = false;
      } else {
        setTANNumberError("");
      }

      // If all is valid, you can now move to the next section
      if (isValid) {
        updateData(4, 1);
        uploadFiles();
      }

      return isValid;
    }
  };

  return (
    <div className="bg-[#F4F5FA] min-h-screen">
      {/* <Header
        toggleSidebar={toggleSidebar}
        isSidebarCollapsed={isSidebarCollapsed}
      />
      <Sidebar
        isSidebarCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
      /> */}

      <main className="main-content">
        <div
          className={`mx-auto p-4 md:p-4 transition-all duration-300 ${
            isSidebarCollapsed && !isMobile
              ? "lg:ml-20"
              : !isSidebarCollapsed && !isMobile
              ? "lg:ml-[270px]"
              : "ml-0"
          }`}
        >
          {/* Section Tabs */}
          <div className="flex justify-center flex-wrap lg:flex-nowrap gap-x-6 p-4">
            {[
              "General Information",
              "Business Address",
              "Bank Details",
              "KYC",
            ].map((section) => (
              <button
                key={section}
                onClick={() => setActiveSection(section)}
                className={`w-64 h-12 rounded-2xl flex items-center justify-center my-2 ${
                  activeSection === section ? "bg-white text-[#299F1F] border border-[1px] border-green-500" : "bg-[#299F1F] text-white text-lg transition-all"
                } `}
              >
                {section}
              </button>
            ))}
          </div>

          {/* Section Content */}
          <div className="space-y-5 sm:space-y-6">
            {activeSection === "General Information" && (
              <div className="space-y-5 sm:space-y-6">
                <div className="rounded-2xl border border-gray-200 bg-white ">
                  <div className="p-5 border-t border-gray-100  sm:p-6">
                    <p className="text-2xl text-[#299F1F]">
                      Account Information :
                    </p>

                    {/* Name & Email */}
                    <div className="mt-5 grid lg:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sl font-medium text-gray-700 mb-1">
                          Name<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="Name"
                          disabled
                          value={formData.contact_name}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              [e.target.contact_name]: e.target.value,
                            })
                          }
                          readOnly={!isEditable.contact_name}
                          placeholder="Name"
                          className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sl"
                        />
                        <p
                          id="NameError"
                          className="text-red-500 text-sm mt-1"
                        ></p>
                      </div>
                      <div>
                        <label className="block text-sl font-medium text-gray-700 mb-1">
                          Email<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="email"
                          id="Email"
                          disabled
                          value={formData.contact_email}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              contact_email: e.target.value,
                            })
                          }
                          readOnly={!isEditable.contact_email}
                          placeholder="Email"
                          className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sl"
                        />
                        <p
                          id="EmailError"
                          className="text-red-500 text-sm mt-1"
                        ></p>
                      </div>
                    </div>

                    {/* Mobile No & Business Type */}
                    <div className="mt-5 grid lg:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sl font-medium text-gray-700 mb-1">
                          Mobile No<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="tel"
                          id="Mobile"
                          maxLength="10"
                          placeholder="Mobile"
                          disabled
                          value={formData.contact_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              contact_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.contact_number}
                          onInput={(e) =>
                            (e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            ))
                          }
                          className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sl"
                        />
                        <p
                          id="MobileError"
                          className="text-red-500 text-sm mt-1"
                        ></p>
                      </div>
                      <div>
                        <label className="block text-sl font-medium text-gray-700 mb-1">
                          Business Type<span className="text-red-500">*</span>
                        </label>
                        <select
                          id="BusinessType"
                          value={businesstype[formData.business_type]}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              business_type: e.target.value,
                            });
                            setSelectedBusinessType(e.target.value); // This will update selectedBusinessType
                          }}
                          disabled={!isEditable.business_type} // Disable if data exists
                          className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sl"
                        >
                          <option value="">Select Business Type</option>
                          <option value="Individual">Individual</option>
                          <option value="LLP">LLP</option>
                          <option value="Partnership">Partnership</option>
                          <option value="Private Limited">
                            Private Limited
                          </option>
                          <option value="Proprietorship">Proprietorship</option>
                          {/* <option value="NGO">NGO</option> */}
                          {/* <option value="NGO">NGO</option> */}
                        </select>
                        <p
                          id="BusinessTypeError"
                          className="text-red-500 text-sm mt-1"
                        ></p>
                      </div>
                    </div>

                    {/* Country & Contact Name */}
                    <div className="mt-5 grid lg:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sl font-medium text-gray-700 mb-1">
                          Country<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="Country"
                          name="Country" // Add name attribute
                          value={formData.Country}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              [e.target.name]: e.target.value,
                            })
                          }
                          readOnly={!isEditable.Country}
                          placeholder="Enter your country"
                          maxLength={50}
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                          className={`w-full px-4 py-2 rounded-md border ${
                            CountryError ? "border-red-500" : "border-gray-300"
                          } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                            CountryError
                              ? "focus:ring-red-400"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />

                        {CountryError && (
                          <p
                            id="CountryError"
                            className="text-red-500 text-sm mt-1"
                          >
                            {" "}
                            {CountryError}
                          </p>
                        )}

                        {/* <p id="CountryError" className="text-red-500 text-sm mt-1"></p> */}
                      </div>
                      <div>
                        <label className="block text-sl font-medium text-gray-700 mb-1">
                          Contact Name<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="ContactName"
                          value={formData.business_cname}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              business_cname: e.target.value,
                            })
                          }
                          readOnly={!isEditable.business_cname}
                          placeholder="Enter your Contact Name"
                          maxLength={120}
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sl"

                          className={`w-full px-4 py-2 rounded-md border ${
                            ContactNameError
                              ? "border-red-500"
                              : "border-gray-300"
                          } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                            ContactNameError
                              ? "focus:ring-red-400"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {ContactNameError && (
                          <p
                            id="ContactNameError"
                            className="text-red-500 text-sm mt-1"
                          >
                            {" "}
                            {ContactNameError}
                          </p>
                        )}

                        {/* <p id="ContactNameError" className="text-red-500 text-sm mt-1"></p> */}
                      </div>
                    </div>

                    {/* Contact Email & Contact Number */}
                    <div className="mt-5 grid lg:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sl font-medium text-gray-700 mb-1">
                          Contact Email<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="email"
                          id="ContactEmail"
                          value={formData.business_email}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              business_email: e.target.value,
                            })
                          }
                          readOnly={!isEditable.business_email}
                          placeholder="Enter your Contact Email"
                          maxLength={120}
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sl"
                          className={`w-full px-4 py-2 rounded-md border ${
                            ContactEmailError
                              ? "border-red-500"
                              : "border-gray-300"
                          } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                            ContactEmailError
                              ? "focus:ring-red-400"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {ContactEmailError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {ContactEmailError}
                          </p>
                        )}

                        {/* <p id="ContactEmailError" className="text-red-500 text-sm mt-1"></p> */}
                      </div>
                      <div>
                        <label className="block text-sl font-medium text-gray-700 mb-1">
                          Contact Number<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="tel"
                          id="ContactNo"
                          placeholder="Enter your Contact Number"
                          maxLength="10"
                          value={formData.business_cnumber}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              business_cnumber: e.target.value,
                            })
                          }
                          readOnly={!isEditable.business_cnumber}
                          onInput={(e) =>
                            (e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            ))
                          }
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sl"
                          className={`w-full px-4 py-2 rounded-md border ${
                            ContactNumberError
                              ? "border-red-500"
                              : "border-gray-300"
                          } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                            ContactNumberError
                              ? "focus:ring-red-400"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />

                        {ContactNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {ContactNumberError}
                          </p>
                        )}
                        {/* <p id="ContactNoError" className="text-red-500 text-sm mt-1"></p> */}
                      </div>
                    </div>

                    {/* Business Name & Business Category */}
                    <div className="mt-5 grid lg:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sl font-medium text-gray-700 mb-1">
                          Business Name<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="BusinessName"
                          value={formData.business_name}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              business_name: e.target.value,
                            })
                          }
                          readOnly={!isEditable.business_name}
                          placeholder="Business Name"
                          disabled
                          className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sl"
                        />

                        {/* { BusinessNameError && (
                            <p id="" className="text-red-500 text-sm mt-1"> {BusinessNameError}</p>
                          )} */}

                        {/* <p id="BusinessNameError" className="text-red-500 text-sm mt-1"></p> */}
                      </div>
                      <div>
                        <label className="block text-sl font-medium text-gray-70 mb-1">
                          Business Category
                          <span className="text-red-500">*</span>
                        </label>
                        <select
                          id="BusinessCategory"
                          value={formData.business_category}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              business_category: e.target.value,
                            })
                          }
                          disabled={!isEditable.business_category} // Use `disabled` instead of `readOnly`
                          // className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sl"
                          className={`w-full px-4 py-2 rounded-md border ${
                            BusinessCatError
                              ? "border-red-500"
                              : "border-gray-300"
                          } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                            BusinessCatError
                              ? "focus:ring-red-400"
                              : "focus:ring-[#299F1F]"
                          }`}
                        >
                          <option value="">Choose Business Category</option>
                          <option value="1">B2B</option>
                          <option value="2">Digital goods</option>
                          <option value="3">Ecommerce</option>
                          <option value="4">Education</option>
                          <option value="5">Proprietorship</option>
                          <option value="6">Financial Services</option>
                        </select>

                        {BusinessCatError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {BusinessCatError}
                          </p>
                        )}

                        {/* <p id="BusinessCategoryError" className="text-red-500 text-sm mt-1"></p> */}
                      </div>
                    </div>

                    {/* Accepting Payments URL & App URL */}
                    <div className="mt-5">
                      <div className="grid lg:grid-cols-2 gap-4 mt-2">
                        <div>
                          <label className="block text-sl font-medium text-gray-700 mb-1">
                            Accepting Payments URL
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="url"
                            id="Acceptingurl"
                            value={formData.accepting_payments}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                accepting_payments: e.target.value,
                              })
                            }
                            readOnly={!isEditable.accepting_payments}
                            placeholder="Enter your Accepting Payments URL"
                            maxLength={150}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sl"
                            className={`w-full px-4 py-2 rounded-md border ${
                              AcceptUrlError
                                ? "border-red-500"
                                : "border-gray-300"
                            } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                              AcceptUrlError
                                ? "focus:ring-red-400"
                                : "focus:ring-[#299F1F]"
                            }`}
                          />

                          {AcceptUrlError && (
                            <p id="" className="text-red-500 text-sm mt-1">
                              {" "}
                              {AcceptUrlError}
                            </p>
                          )}
                          {/* <p id="AcceptingurlError" className="text-red-500 text-sm mt-1"></p> */}
                        </div>
                        <div>
                          <label className="block text-sl font-medium text-gray-700 mb-1">
                            App URL<span className="text-red-500">*</span>
                          </label>
                          <input
                            type="url"
                            id="Appurl"
                            value={formData.app_link}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                app_link: e.target.value,
                              })
                            }
                            readOnly={!isEditable.app_link}
                            placeholder="Enter your App URL"
                            maxLength={150}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sl"
                            className={`w-full px-4 py-2 rounded-md border ${
                              AppUrlError ? "border-red-500" : "border-gray-300"
                            } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                              AppUrlError
                                ? "focus:ring-red-400"
                                : "focus:ring-[#299F1F]"
                            }`}
                          />

                          {AppUrlError && (
                            <p id="" className="text-red-500 text-sm mt-1">
                              {" "}
                              {AppUrlError}
                            </p>
                          )}

                          {/* <p id="AppurlError" className="text-red-500 text-sm mt-1"></p> */}
                        </div>
                        <div>
                          <div class="grid mt-2 ">
                            <div className="w-full">
                              <label class="block text-sl font-medium text-gray-700 mb-1">
                                Business Description
                                <span class="text-red-500">*</span>
                              </label>
                              <textarea
                                type="text"
                                id="Description"
                                value={formData.business_description}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    business_description: e.target.value,
                                  })
                                }
                                readOnly={!isEditable.business_description}
                                placeholder="Enter your Business Description"
                                maxLength={220}
                                // class="mt-3 lg:w-[600px] px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sl"
                                className={`w-full px-4 py-2 rounded-md border ${
                                  DescriptionError
                                    ? "border-red-500"
                                    : "border-gray-300"
                                } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                                  DescriptionError
                                    ? "focus:ring-red-400"
                                    : "focus:ring-[#299F1F]"
                                }`}
                              ></textarea>

                              {DescriptionError && (
                                <p id="" className="text-red-500 text-sm mt-1">
                                  {" "}
                                  {DescriptionError}
                                </p>
                              )}

                              {/* <p id="DescriptionError" class="text-red-500 text-sm mt-1"></p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Next Button */}
                    <div className="flex justify-end w-full">
                      <button
                        id="nextButton"
                        type="button"
                        onClick={() => {
                          GeneralInformationInput();
                        }}
                        className="text-sl w-20 flex justify-center bg-[#299F1F] text-white py-2 p-3 rounded-md mt-4"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Business Addreasss */}

            {activeSection === "Business Address" && (
              <div className="rounded-2xl border border-gray-200 bg-white p-6">
                <p className="text-2xl text-[#299F1F]">Business Address:</p>
                <div className="mt-5 grid lg:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sl font-medium text-gray-700 mb-1">
                      Address<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Address"
                      maxLength={200}
                      value={formData.address}
                      onChange={(e) =>
                        setFormData({ ...formData, address: e.target.value })
                      }
                      readOnly={!isEditable.address}
                      // className="mt-3 lg:w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                      className={`w-full px-4 py-2 rounded-md border ${
                        AddressError ? "border-red-500" : "border-gray-300"
                      } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                        AddressError
                          ? "focus:ring-red-400"
                          : "focus:ring-[#299F1F]"
                      }`}
                    />

                    {AddressError && (
                      <p id="" className="text-red-500 text-sm mt-1">
                        {" "}
                        {AddressError}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sl font-medium text-gray-700 mb-1">
                      Pincode<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Pincode"
                      maxLength={6}
                      value={formData.pincode}
                      onChange={(e) =>
                        setFormData({ ...formData, pincode: e.target.value })
                      }
                      readOnly={!isEditable.pincode}
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      // className="mt-3 lg:w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                      className={`w-full px-4 py-2 rounded-md border ${
                        PincodeError ? "border-red-500" : "border-gray-300"
                      } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                        PincodeError
                          ? "focus:ring-red-400"
                          : "focus:ring-[#299F1F]"
                      }`}
                    />
                    {PincodeError && (
                      <p id="" className="text-red-500 text-sm mt-1">
                        {" "}
                        {PincodeError}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sl font-medium text-gray-700 mb-1">
                      City<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="City"
                      maxLength={120}
                      value={formData.city}
                      onChange={(e) =>
                        setFormData({ ...formData, city: e.target.value })
                      }
                      readOnly={!isEditable.city}
                      // className="mt-3 lg:w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                      className={`w-full px-4 py-2 rounded-md border ${
                        CityError ? "border-red-500" : "border-gray-300"
                      } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                        CityError
                          ? "focus:ring-red-400"
                          : "focus:ring-[#299F1F]"
                      }`}
                    />
                    {CityError && (
                      <p id="" className="text-red-500 text-sm mt-1">
                        {" "}
                        {CityError}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sl font-medium text-gray-700 mb-1">
                      State<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="State"
                      maxLength={120}
                      value={formData.state}
                      onChange={(e) =>
                        setFormData({ ...formData, state: e.target.value })
                      }
                      readOnly={!isEditable.state}
                      // className="mt-3 lg:w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                      className={`w-full px-4 py-2 rounded-md border ${
                        StateError ? "border-red-500" : "border-gray-300"
                      } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                        StateError
                          ? "focus:ring-red-400"
                          : "focus:ring-[#299F1F]"
                      }`}
                    />
                    {StateError && (
                      <p id="" className="text-red-500 text-sm mt-1">
                        {" "}
                        {StateError}
                      </p>
                    )}
                  </div>
                </div>

                <div class="flex justify-end w-full gap-2">
                  <button
                    id="PerviousButton"
                    onClick={() => setActiveSection("General Information")}
                    class="text-sl w-30 flex justify-center bg-[#299F1F] text-white py-2 p-3 rounded-md mt-4"
                  >
                    Pervious
                  </button>
                  <button
                    id="nextButton"
                    // onClick={() => { setActiveSection("Bank Details")
                    //   updateData(2);
                    // }}
                    onClick={() => {
                      BusinessAddressInput();
                    }}
                    class="text-sl w-20 flex justify-center bg-[#299F1F] text-white py-2 p-3 rounded-md mt-4"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}

            {activeSection === "Bank Details" && (
              <div className="rounded-2xl border border-gray-200 bg-white p-6">
                <p className="text-2xl text-[#299F1F]">Bank Details:</p>
                <div class="mt-5">
                  <div>
                    <div>
                      <p class="block text-sl font-medium text-gray-700 mb-1 mt-4">
                        Type of Bank Account :
                      </p>
                      <div class="flex items-center gap-2 mt-3">
                        <input
                          type="radio"
                          id="currentAccount"
                          name="bankAccountType"
                          class="cursor-pointer"
                          checked
                        />
                        <label for="currentAccount" class="text-sl">
                          Current Account
                        </label>
                      </div>
                    </div>

                    <div>
                      <label class="block text-sl font-medium text-gray-700 mt-4 mb-1">
                        Account Number<span class="text-red-500">*</span>
                      </label>
                      <input
                        type="tel"
                        id="AccountNumber"
                        placeholder="Enter your Account Number"
                        maxlength="25"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                        value={formData.bank_account_number}
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            bank_account_number: e.target.value,
                          })
                        }
                        readOnly={!isEditable.bank_account_number}
                        // class="mt-3 lg:w-[600px] px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        className={`lg:w-[600px] px-4 py-2 rounded-md border ${
                          AccountNumberError
                            ? "border-red-500"
                            : "border-gray-300"
                        } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                          AccountNumberError
                            ? "focus:ring-red-400"
                            : "focus:ring-[#299F1F]"
                        }`}
                      />
                      {AccountNumberError && (
                        <p id="" className="text-red-500 text-sm mt-1">
                          {" "}
                          {AccountNumberError}
                        </p>
                      )}
                      {/* <p id="accountNumberError" class="text-red-500 text-sm mt-1"></p> */}
                    </div>

                    <div>
                      <label class="block text-sl font-medium text-gray-700 mt-4 mb-1">
                        Account IFSC<span class="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="AccountIFSC"
                        placeholder="Enter your Account IFSC"
                        maxlength="25"
                        value={formData.bank_ifsc_code}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            bank_ifsc_code: e.target.value,
                          })
                        }
                        readOnly={!isEditable.bank_ifsc_code}
                        // class="mt-3 lg:w-[600px] px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        className={`lg:w-[600px] px-4 py-2 rounded-md border ${
                          BankIFSCError ? "border-red-500" : "border-gray-300"
                        } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                          BankIFSCError
                            ? "focus:ring-red-400"
                            : "focus:ring-[#299F1F]"
                        }`}
                      />
                      {BankIFSCError && (
                        <p id="" className="text-red-500 text-sm mt-1">
                          {" "}
                          {BankIFSCError}
                        </p>
                      )}
                      {/* <p id="accountIFSCError" class="text-red-500 text-sm mt-1"></p> */}
                    </div>

                    <div>
                      <label class="block text-sl font-medium text-gray-700 mt-4 mb-1">
                        Bank Name<span class="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="BankName"
                        placeholder="Enter your Bank Name"
                        maxlength="50"
                        value={formData.bank_name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            bank_name: e.target.value,
                          })
                        }
                        readOnly={!isEditable.bank_name}
                        // class="mt-3 lg:w-[600px] px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        className={`lg:w-[600px] px-4 py-2 rounded-md border ${
                          BankNameError ? "border-red-500" : "border-gray-300"
                        } focus:outline-none focus:ring-2 placeholder:text-sl text-sl ${
                          BankNameError
                            ? "focus:ring-red-400"
                            : "focus:ring-[#299F1F]"
                        }`}
                      />
                      {BankNameError && (
                        <p id="" className="text-red-500 text-sm mt-1">
                          {" "}
                          {BankNameError}
                        </p>
                      )}
                      {/* <p id="bankNameError" class="text-red-500 text-sm mt-1"></p> */}
                    </div>

                    <div class="flex justify-end w-full gap-2">
                      <button
                        id="PreviousButton"
                        onClick={() => setActiveSection("Business Address")}
                        class="text-sm w-30 flex justify-center bg-[#299F1F] text-white py-2 px-4 rounded-md mt-4"
                      >
                        Previous
                      </button>
                      <button
                        id="nextButton"
                        //   onClick={() => {setActiveSection("KYC"); updateData(3);}
                        // }
                        onClick={() => {
                          BankDetailsInput();
                        }}
                        class="text-sm w-20 flex justify-center bg-[#299F1F] text-white py-2 px-4 rounded-md mt-4"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeSection === "KYC" && (
              <div className="rounded-2xl border border-gray-200 bg-white p-6">
                <p className="text-2xl text-[]">KYC Details:</p>
                <div className="mt-5">
                  {/* Individual Documents */}

                  {selectedBusinessType === "Individual" && (
                    <div className="grid lg:grid-cols-2 gap-4 mt-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Individual PAN <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.individual_pan}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              individual_pan: e.target.value,
                            })
                          }
                          readOnly={!isEditable.individual_pan}
                          placeholder="Individual PAN"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-3 ${
                            IndiPanNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {IndiPanNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {IndiPanNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach Individual PAN (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.individual_pan_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.individual_pan_image)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  individual_pan_image: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="individual_pan_image"
                            onChange={(e) =>
                              handleFileChange(e, setindividual_pan_image)
                            }
                            // disabled={!isEditable.individual_pan_image}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-3 ${
                              IndiPanFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {IndiPanFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {IndiPanFileError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Aadhar Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.aadhar_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              aadhar_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.aadhar_number}
                          placeholder="Aadhar Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-3 ${
                            IndiAadharNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {IndiAadharNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {IndiAadharNumberError}
                          </p>
                        )}
                      </div>
                      {/* Aadhar File */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach Aadhar File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.aadhar_file ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.aadhar_file)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({ ...formData, aadhar_file: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="aadhar_file"
                            onChange={(e) =>
                              handleFileChange(e, setaadhar_file)
                            }
                            // disabled={!isEditable.aadhar_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-3 ${
                              IndiAadharFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}

                        {IndiAadharFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {IndiAadharFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="nblock text-sm font-medium text-gray-700">
                          GST Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.gst_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              gst_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.gst_number}
                          placeholder="PAN Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-3 ${
                            IndiGSTNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {IndiGSTNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {IndiGSTNumberError}
                          </p>
                        )}
                      </div>
                      {/* GST File */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach GST File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.gst_file ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() => handleViewFile(formData.gst_file)}
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({ ...formData, gst_file: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="gst_file"
                            onChange={(e) => handleFileChange(e, setgst_file)}
                            // disabled={!isEditable.gst_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-3 ${
                              IndiGSTFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {IndiGSTFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {IndiGSTFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          ID Proof Number (Voter ID or Driving License){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.id_document_num}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              id_document_num: e.target.value,
                            })
                          }
                          readOnly={!isEditable.id_document_num}
                          placeholder="ID Proof Number (Voter ID or Driving License)"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-3 ${
                            IndiIDProofError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {IndiIDProofError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {IndiIDProofError}
                          </p>
                        )}
                      </div>
                      {/* ID Proof File */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          ID Proof File (Voter ID or Driving License) (Max Size:
                          1Mb) <span className="text-red-500">*</span>
                        </label>
                        {formData.id_proof_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.id_proof_image)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  id_proof_image: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="id_proof_image"
                            onChange={(e) =>
                              handleFileChange(e, setid_proof_image)
                            }
                            // disabled={!isEditable.id_proof_image}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-3 ${
                              IndiIDProofFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {IndiIDProofFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {IndiIDProofFileError}
                          </p>
                        )}
                      </div>

                      {/* Canceled Cheque File */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Cancelled Cheque File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.canceled_cheque ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.canceled_cheque)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  canceled_cheque: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="canceled_cheque"
                            onChange={(e) =>
                              handleFileChange(e, setcanceled_cheque)
                            }
                            // disabled={!isEditable.canceled_cheque}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-3 ${
                              IndiCancelChequeError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {IndiCancelChequeError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {IndiCancelChequeError}
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                  {/* LLP Documents */}
                  {selectedBusinessType === "LLP" && (
                    <div className="grid lg:grid-cols-2 gap-4 mt-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Company Pan Number{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.company_pan}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              company_pan: e.target.value,
                            })
                          }
                          readOnly={!isEditable.company_pan}
                          placeholder="Enter your Company Pan Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"

                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            llpCompanyPanNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {llpCompanyPanNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {llpCompanyPanNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Attach Company Pan Number (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.company_pan_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.company_pan_image)
                              }
                              className="px-1 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  company_pan_image: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="Company Pan Number"
                            onChange={(e) =>
                              handleFileChange(e, setcompany_pan_image)
                            }
                            // disabled={!isEditable.aadhar_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              llpCompanyPanFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg, .jpeg, .png, .pdf"
                          />
                        )}
                        {llpCompanyPanFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {llpCompanyPanFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Pan Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.pan_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              pan_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.pan_number}
                          placeholder="Pan Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            llpPanNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {llpPanNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {llpPanNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Attach Pan File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.pan_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() => handleViewFile(formData.pan_image)}
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({ ...formData, pan_image: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="aadhar_file"
                            onChange={(e) => handleFileChange(e, setpan_image)}
                            // disabled={!isEditable.aadhar_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            // accept="image/*"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              llpPanNumberError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg, .jpeg, .png, .pdf"
                          />
                        )}
                        {llpPanFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {llpPanFileError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Aadhar Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.aadhar_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              aadhar_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.aadhar_number}
                          placeholder="Aadhar Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            llpAadharNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {llpAadharNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {llpAadharNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach Aadhar File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.aadhar_file ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.aadhar_file)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({ ...formData, aadhar_file: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="aadhar_file"
                            onChange={(e) =>
                              handleFileChange(e, setaadhar_file)
                            }
                            // disabled={!isEditable.aadhar_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              llpAadharFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg, .jpeg, .png, .pdf"
                          />
                        )}

                        {llpAadharFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {llpAadharFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          GST Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.gst_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              gst_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.gst_number}
                          placeholder="GST Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            llpGSTNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {llpGSTNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {llpGSTNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach GST File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.gst_file ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() => handleViewFile(formData.gst_file)}
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({ ...formData, gst_file: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="gst_file"
                            onChange={(e) => handleFileChange(e, setgst_file)}
                            // disabled={!isEditable.gst_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              llpGSTFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {llpGSTFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {llpGSTFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          ID Proof Number (Voter ID or Driving License){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.id_document_num}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              id_document_num: e.target.value,
                            })
                          }
                          readOnly={!isEditable.id_document_num}
                          placeholder="ID Proof Number (Voter ID or Driving License)"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            llpIDProofNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {llpIDProofNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {llpIDProofNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          ID Proof File (Voter ID or Driving License) (Max Size:
                          1Mb) <span className="text-red-500">*</span>
                        </label>
                        {formData.id_proof_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.id_proof_image)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  id_proof_image: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="id_proof_image"
                            onChange={(e) =>
                              handleFileChange(e, setid_proof_image)
                            }
                            // disabled={!isEditable.id_proof_image}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              llpIDProofFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {llpIDProofFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {llpIDProofFileError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          LLP Certificate (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.llp_cerificate_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.llp_cerificate_image)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  llp_cerificate_image: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="aadhar_file"
                            onChange={(e) =>
                              handleFileChange(e, setllp_cerificate_image)
                            }
                            // disabled={!isEditable.aadhar_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              LLPCertificateError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {LLPCertificateError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {LLPCertificateError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Cancel cheque File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.canceled_cheque ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.canceled_cheque)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  canceled_cheque: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="canceled_cheque"
                            onChange={(e) =>
                              handleFileChange(e, setcanceled_cheque)
                            }
                            // disabled={!isEditable.canceled_cheque}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              llpCancelChequeError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {llpCancelChequeError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {llpCancelChequeError}
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                  {/* PartnerShip Documents */}
                  {selectedBusinessType === "Partnership" && (
                    <div className="grid lg:grid-cols-2 gap-4 mt-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Company Pan Number{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.company_pan}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              company_pan: e.target.value,
                            })
                          }
                          readOnly={!isEditable.company_pan}
                          placeholder="Company Pan Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            parCompanyPanNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {parCompanyPanNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {parCompanyPanNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach Company Pan File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.company_pan_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.company_pan_image)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  company_pan_image: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="aadhar_file"
                            onChange={(e) =>
                              handleFileChange(e, setcompany_pan_image)
                            }
                            // disabled={!isEditable.aadhar_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              parCompanyPanFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {parCompanyPanFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {parCompanyPanFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Pan Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.pan_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              pan_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.pan_number}
                          placeholder="Pan Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            parPanNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {parPanNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {parPanNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach Pan File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.pan_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() => handleViewFile(formData.pan_image)}
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({ ...formData, pan_image: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="aadhar_file"
                            onChange={(e) => handleFileChange(e, setpan_image)}
                            // disabled={!isEditable.aadhar_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              parPanFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {parPanFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {parPanFileError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Aadhar Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.aadhar_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              aadhar_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.aadhar_number}
                          placeholder="Aadhar Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            parAadharNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {parAadharNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {parAadharNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach Aadhar File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.aadhar_file ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.aadhar_file)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({ ...formData, aadhar_file: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="aadhar_file"
                            onChange={(e) =>
                              handleFileChange(e, setaadhar_file)
                            }
                            // disabled={!isEditable.aadhar_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              parAadharFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {parAadharFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {parAadharFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          GST Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.gst_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              gst_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.gst_number}
                          placeholder="GST Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            parGSTNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {parGSTNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {parGSTNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach GST File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.gst_file ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() => handleViewFile(formData.gst_file)}
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>

                            <button
                              onClick={() =>
                                setFormData({ ...formData, gst_file: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="gst_file"
                            onChange={(e) => handleFileChange(e, setgst_file)}
                            // disabled={!isEditable.gst_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              parGSTFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {parGSTFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {parGSTFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          ID Proof Number (Voter ID or Driving License){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.id_document_num}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              id_document_num: e.target.value,
                            })
                          }
                          readOnly={!isEditable.id_document_num}
                          placeholder="ID Proof Number (Voter ID or Driving License)"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            parIDProofNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {parIDProofNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {parIDProofNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          ID Proof File (Voter ID or Driving License) (Max Size:
                          1Mb) <span className="text-red-500">*</span>
                        </label>
                        {formData.id_proof_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.id_proof_image)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  id_proof_image: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="id_proof_image"
                            onChange={(e) =>
                              handleFileChange(e, setid_proof_image)
                            }
                            // disabled={!isEditable.id_proof_image}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              parIDProofFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {parIDProofFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {parIDProofFileError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          PartnerShip Deed File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.partnership_deed ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.partnership_deed)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  partnership_deed: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="canceled_cheque"
                            onChange={(e) =>
                              handleFileChange(e, setpartnership_deed)
                            }
                            // disabled={!isEditable.canceled_cheque}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              PartnerShipFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {PartnerShipFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {PartnerShipFileError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Cancel Cheque File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.canceled_cheque ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.canceled_cheque)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  canceled_cheque: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="canceled_cheque"
                            onChange={(e) =>
                              handleFileChange(e, setcanceled_cheque)
                            }
                            // disabled={!isEditable.canceled_cheque}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              parCancelChequeErrorError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {parCancelChequeErrorError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {parCancelChequeErrorError}
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Private Limited Documents */}
                  {selectedBusinessType === "Private Limited" && (
                    <div className="grid lg:grid-cols-2 gap-4 mt-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Company Pan Number{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.company_pan}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              company_pan: e.target.value,
                            })
                          }
                          readOnly={!isEditable.company_pan}
                          placeholder="Company Pan Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            CompanyPanNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {CompanyPanNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {CompanyPanNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach Company Pan Number (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.company_pan_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.company_pan_image)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  company_pan_image: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="aadhar_file"
                            onChange={(e) =>
                              handleFileChange(e, setcompany_pan_image)
                            }
                            // disabled={!isEditable.aadhar_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              CompanyPanFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {CompanyPanFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {CompanyPanFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Pan Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.pan_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              pan_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.pan_number}
                          placeholder="Pan Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            PanNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {PanNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {PanNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach Pan Number (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.pan_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() => handleViewFile(formData.pan_image)}
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({ ...formData, pan_image: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="aadhar_file"
                            onChange={(e) => handleFileChange(e, setpan_image)}
                            // disabled={!isEditable.aadhar_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              PanFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {PanFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {PanFileError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Aadhar Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.aadhar_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              aadhar_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.aadhar_number}
                          placeholder="Aadhar Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            AadharNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {AadharNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {AadharNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach Aadhar File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.aadhar_file ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.aadhar_file)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({ ...formData, aadhar_file: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="aadhar_file"
                            onChange={(e) =>
                              handleFileChange(e, setaadhar_file)
                            }
                            // disabled={!isEditable.aadhar_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              AadharNumberError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {AadharFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {AadharFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          GST Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.gst_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              gst_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.gst_number}
                          placeholder="GST Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            GSTNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {GSTNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {GSTNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach GST File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.gst_file ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() => handleViewFile(formData.gst_file)}
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({ ...formData, gst_file: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="gst_file"
                            onChange={(e) => handleFileChange(e, setgst_file)}
                            // disabled={!isEditable.gst_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              GSTFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {GSTFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {GSTFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          CIN Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.cin_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              cin_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.cin_number}
                          placeholder="CIN Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            CINNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {CINNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {CINNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach CIN Number File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.cin_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() => handleViewFile(formData.cin_image)}
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({ ...formData, cin_image: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="canceled_cheque"
                            onChange={(e) => handleFileChange(e, setcin_image)}
                            // disabled={!isEditable.canceled_cheque}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              CINFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {CINFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {CINFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach MOA AOA File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.moa_aoa_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.moa_aoa_image)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>

                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  moa_aoa_image: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="canceled_cheque"
                            onChange={(e) =>
                              handleFileChange(
                                e,
                                setmoa_aoa_image,
                                setMOAAOAFileError
                              )
                            }
                            // disabled={!isEditable.canceled_cheque}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              MOAAOAFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {MOAAOAFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {MOAAOAFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach AOA File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.aoa_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() => handleViewFile(formData.aoa_image)}
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>

                            <button
                              onClick={() =>
                                setFormData({ ...formData, aoa_image: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="canceled_cheque"
                            onChange={(e) => handleFileChange(e, setaoa_image)}
                            // disabled={!isEditable.canceled_cheque}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              AOAFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                           accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {AOAFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {AOAFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          ID Proof Number (Voter ID or Driving License){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.id_document_num}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              id_document_num: e.target.value,
                            })
                          }
                          readOnly={!isEditable.id_document_num}
                          placeholder="ID Proof Number (Voter ID or Driving License)"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            IDProofNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {IDProofNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {IDProofNumberError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          ID Proof File (Voter ID or Driving License) (Max Size:
                          1Mb) <span className="text-red-500">*</span>
                        </label>
                        {formData.id_proof_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.id_proof_image)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  id_proof_image: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="id_proof_image"
                            onChange={(e) =>
                              handleFileChange(e, setid_proof_image)
                            }
                            // disabled={!isEditable.id_proof_image}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              IDProofFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {IDProofFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {IDProofFileError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Cancel cheque File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.canceled_cheque ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.canceled_cheque)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  canceled_cheque: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="canceled_cheque"
                            onChange={(e) =>
                              handleFileChange(e, setcanceled_cheque)
                            }
                            // disabled={!isEditable.canceled_cheque}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              CancelChequeError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {CancelChequeError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {CancelChequeError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          TAN Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="Text"
                          value={formData.tan_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              tan_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.tan_number}
                          placeholder="TAN Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            TANNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {TANNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {TANNumberError}
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                  {/* ProparaterShip Documents */}
                  {selectedBusinessType === "Proprietorship" && (
                    <div className="grid lg:grid-cols-2 gap-4 mt-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Proprietor Pan Number{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.proprietorship_pan}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              proprietorship_pan: e.target.value,
                            })
                          }
                          readOnly={!isEditable.proprietorship_pan}
                          placeholder="Company Pan Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            ProprietorPanNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {ProprietorPanNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {ProprietorPanNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach Proprietor Pan Number (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.proprietorship_pan_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(
                                  formData.proprietorship_pan_image
                                )
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  proprietorship_pan_image: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="aadhar_file"
                            onChange={(e) =>
                              handleFileChange(e, setproprietorship_pan_image)
                            }
                            // disabled={!isEditable.aadhar_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                             className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              ProprietorPanFileError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {ProprietorPanFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {ProprietorPanFileError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Aadhar Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.aadhar_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              aadhar_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.aadhar_number}
                          placeholder="Aadhar Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            ProAadharNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {ProAadharNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {ProAadharNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach Aadhar File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.aadhar_file ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.aadhar_file)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({ ...formData, aadhar_file: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="aadhar_file"
                            onChange={(e) =>
                              handleFileChange(e, setaadhar_file)
                            }
                            // disabled={!isEditable.aadhar_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              ProAadharFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {ProAadharFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {ProAadharFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          GST Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.gst_number}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              gst_number: e.target.value,
                            })
                          }
                          readOnly={!isEditable.gst_number}
                          placeholder="GST Number"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            ProGSTNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {ProGSTNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {ProGSTNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Attach GST File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.gst_file ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() => handleViewFile(formData.gst_file)}
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({ ...formData, gst_file: null })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="gst_file"
                            onChange={(e) => handleFileChange(e, setgst_file)}
                            // disabled={!isEditable.gst_file}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              ProGSTFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {ProGSTFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {ProGSTFileError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          ID Proof Number (Voter ID or Driving License){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.id_document_num}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              id_document_num: e.target.value,
                            })
                          }
                          readOnly={!isEditable.id_document_num}
                          placeholder="ID Proof Number (Voter ID or Driving License)"
                          // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                            ProIDProofNumberError
                              ? "border-[#DC2626] focus:ring-[#DC2626]"
                              : "focus:ring-[#299F1F]"
                          }`}
                        />
                        {ProIDProofNumberError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {ProIDProofNumberError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          ID Proof File (Voter ID or Driving License) (Max Size:
                          1Mb) <span className="text-red-500">*</span>
                        </label>
                        {formData.id_proof_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.id_proof_image)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  id_proof_image: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="id_proof_image"
                            onChange={(e) =>
                              handleFileChange(e, setid_proof_image)
                            }
                            // disabled={!isEditable.id_proof_image}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              ProIDProofFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {ProIDProofFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {ProIDProofFileError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Register Certificate (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.reg_certificate_image ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.reg_certificate_image)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  reg_certificate_image: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="id_proof_image"
                            onChange={(e) =>
                              handleFileChange(e, setreg_certificate_image)
                            }
                            // disabled={!isEditable.id_proof_image}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              ProRegisterFileError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {ProRegisterFileError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {ProRegisterFileError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Cancel Cheque File (Max Size: 1Mb){" "}
                          <span className="text-red-500">*</span>
                        </label>
                        {formData.canceled_cheque ? (
                          <div className="mt-2 flex items-center gap-2">
                            <button
                              onClick={() =>
                                handleViewFile(formData.canceled_cheque)
                              }
                              className="px-2 py-1 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                            >
                              View File
                            </button>
                            <button
                              onClick={() =>
                                setFormData({
                                  ...formData,
                                  canceled_cheque: null,
                                })
                              }
                              className="px-2 py-1 text-sm text-white bg-red-500 rounded-md hover:bg-red-600"
                            >
                              Change
                            </button>
                          </div>
                        ) : (
                          <input
                            type="file"
                            name="canceled_cheque"
                            onChange={(e) =>
                              handleFileChange(e, setcanceled_cheque)
                            }
                            // disabled={!isEditable.id_proof_image}
                            // className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            className={`w-full p-1.5 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                              ProCancelChequeError
                                ? "border-[#DC2626] focus:ring-[#DC2626]"
                                : "focus:ring-[#299F1F]"
                            }`}
                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        )}
                        {ProCancelChequeError && (
                          <p id="" className="text-red-500 text-sm mt-1">
                            {" "}
                            {ProCancelChequeError}
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                  {/* NGO Documents
                {selectedBusinessType === "NGO" && (
                     <div className="grid lg:grid-cols-2 gap-4 mt-4">
                     <div>
                       <label className="block text-sm font-medium text-gray-700">
                         Individual PAN <span className="text-red-500">*</span>
                       </label>
                       <input
                         type="text"
                         placeholder="Individual PAN"
                         className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                       />
                     </div>
                     <div>
                       <label className="block text-sm font-medium text-gray-700">
                         Attach Individual Pan (Max Size: 1Mb) <span className="text-red-500">*</span>
                       </label>
                       <input
                         type="file"
                         className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                       />
                     </div>
                     <div>
                       <label className="block text-sm font-medium text-gray-700">
                         Aadhar Number <span className="text-red-500">*</span>
                       </label>
                       <input
                         type="text"
                         placeholder="Aadhar Number"
                         className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                       />
                     </div>
                     <div>
                       <label className="block text-sm font-medium text-gray-700">
                         Attach Aadhar File (Max Size: 1Mb) <span className="text-red-500">*</span>
                       </label>
                       <input
                         type="file"
                         className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                       />
                     </div>
                     <div>
                       <label className="block text-sm font-medium text-gray-700">
                         GST Number <span className="text-red-500">*</span>
                       </label>
                       <input
                         type="text"
                         placeholder="PAN Number"
                         className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                       />
                     </div>
                     <div>
                       <label className="block text-sm font-medium text-gray-700">
                         Attach GST File (Max Size: 1Mb) <span className="text-red-500">*</span>
                       </label>
                       <input
                         type="file"
                         className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                       />
                     </div>
                     <div>
                       <label className="block text-sm font-medium text-gray-700">
                         ID Proof Number (Voter ID or Driving License) <span className="text-red-500">*</span>
                       </label>
                       <input
                         type="text"
                         placeholder="PAN Number"
                         className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                       />
                     </div>
                     <div>
                       <label className="block text-sm font-medium text-gray-700">
                       ID Proof File (Voter ID or Driving License) (Max Size: 1Mb) <span className="text-red-500">*</span>
                       </label>
                       <input
                         type="file"
                         className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                       />
                     </div>
                     
                     <div>
                       <label className="block text-sm font-medium text-gray-700">
                       Cancel cheque File (Max Size: 1Mb) <span className="text-red-500">*</span>
                       </label>
                       <input
                         type="file"
                         className="mt-3 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                       />
                     </div>

                   </div>
                  )} */}

                  <div class="flex justify-end w-full gap-2">
                    <button
                      id="PreviousButton"
                      onClick={() => {
                        setActiveSection("Bank Details");
                      }}
                      class="text-sm w-30 flex justify-center bg-[#299F1F] text-white py-2 px-4 rounded-md mt-4"
                    >
                      Previous
                    </button>
                    <button
                      id="nextButton"
                      // onClick={() => {

                      // }}

                      onClick={() => {
                        KYCSubmitInput();
                      }}
                      class="text-sm w-20 flex justify-center bg-[#299F1F] text-white py-2 px-4 rounded-md mt-4"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Kyc;
